export default "__VITE_ASSET__BC0EEQXT__"